import TextField from "@mui/material/TextField";

export default function MText(props) {
  return (
    <TextField
      error={props.error && props.error.length > 0 ? true : false}
      helperText={props.error}
      type={props.type}
      variant={props.variant ? props.variant : "outlined"}
      value={props.value}
      label={props.label}
      onChange={(e) => {
        if (props.onChange) props.onChange(e);
      }}
      disabled={props.disabled}
      fullWidth={true}
      autoFocus={props.autoFocus}
      InputProps={{
        readOnly: props.readOnly ? props.readOnly : false,
      }}
      style={props.style}
    />
  );
}
